import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { RecruitmentTechnologiesService } from './recruitment-technologies.service';
const service = new RecruitmentTechnologiesService();

export interface RecruitmentTechnologiesState {}

const RecruitmentTechnologiesStore: Module<RecruitmentTechnologiesState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getAccessToken() {
         return await service.getAccessToken();
      },
   },
};

export default RecruitmentTechnologiesStore;
